import React from "react";

/**
 * Storefront icon for Marketplace sidebar navigation.
 */
function MarketplaceIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 10.5V19C4 19.5523 4.44772 20 5 20H9.5V15.5C9.5 14.6716 10.1716 14 11 14H13C13.8284 14 14.5 14.6716 14.5 15.5V20H19C19.5523 20 20 19.5523 20 19V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.5L4.8 5.4C4.925 5.05 5.26 4.82 5.64 4.82H18.36C18.74 4.82 19.075 5.05 19.2 5.4L21 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 10.5C6 11.3284 6.67157 12 7.5 12C8.32843 12 9 11.3284 9 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 10.5C9 11.3284 9.67157 12 10.5 12C11.3284 12 12 11.3284 12 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 10.5C12 11.3284 12.6716 12 13.5 12C14.3284 12 15 11.3284 15 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 10.5C15 11.3284 15.6716 12 16.5 12C17.3284 12 18 11.3284 18 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18 10.5C18 11.3284 18.6716 12 19.5 12C20.3284 12 21 11.3284 21 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default MarketplaceIcon;
